// extracted by mini-css-extract-plugin
export default {"filtersToggleContainer":"search_query_section_commentaries-module__filtersToggleContainer--2a7va"};